import Screens from '../screens';
import PrivateRoute from './PrivateRoute';
import Editor from '../components/elements/Editor';

const routes = [
  {
    key: 'home',
    path: '/',
    exact: true,
    component: Screens.Home,
  },
  {
    key: 'bai-viet',
    path: '/bai-viet/:code',
    component: Screens.Article,
  },
  {
    key: 'danh-muc',
    path: '/danh-muc/:code',
    component: Screens.Category,
  },
  {
    key: 'thong-bao',
    path: '/thong-bao',
    component: Screens.Announcement,
  },
  {
    key: 'trang',
    path: '/trang/:code',
    component: Screens.Page,
  },
  {
    key: 'editor',
    path: '/editor',
    component: Editor,
  },
];

const privateRoutes = [
  {
    key: 'login',
    path: '/login',
    isRedirect: (isAuth) => isAuth,
    redirect: '/dashboard',
    component: Screens.Login,
  },
  {
    key: 'dashboard',
    path: '/dashboard',
    isRedirect: (isAuth) => !isAuth,
    redirect: '/login',
    component: Screens.Dashboard,
  },
];

export {
  routes,
  privateRoutes,
  PrivateRoute,
};



// WEBPACK FOOTER //
// ./src/routes/index.js